import React, { useState, useEffect } from 'react';
import { apis, apiHolder as api } from 'api';
import './index.scss';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
import DeliveryInfo from './components/DeliveryInfo/DeliveryInfo';
import DeliveryRecords from './components/DeliveryRecords/DeliveryRecords';
import message from '@web-common/components/UI/Message/SiriusMessage';
import useGetUniqReqWrap, { ERROR_REQUEST_CANCLE } from '@web-common/hooks/useGetUniqReqWrap';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
const WmMailDeliveryHistory = ({ mid, content }) => {
    const [recordInfo, setRecordInfo] = useState(null);
    const requestDeliveryWm = useGetUniqReqWrap(mailApi.requestDeliveryWm.bind(mailApi));
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        setRecordInfo(null);
        if (((_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.systemLabel) === null || _b === void 0 ? void 0 : _b.length) && (((_d = (_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.systemLabel) === null || _d === void 0 ? void 0 : _d.includes(3)) || ((_f = (_e = content === null || content === void 0 ? void 0 : content.entry) === null || _e === void 0 ? void 0 : _e.systemLabel) === null || _f === void 0 ? void 0 : _f.includes(4)))) {
            handleRefresh();
        }
    }, [mid]);
    const handleRefresh = () => {
        const userInfo = systemApi.getCurrentUser(content === null || content === void 0 ? void 0 : content._account);
        return requestDeliveryWm({
            mid,
            showOnlyInProcess: false,
            _account: content === null || content === void 0 ? void 0 : content._account,
            sid: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.sessionId) || '',
            node: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.node) || '',
        })
            .then(res => {
            setRecordInfo(res);
        })
            .catch(err => {
            if (err !== ERROR_REQUEST_CANCLE) {
                message.error(getIn18Text('HUOQUYOUJFFJLSB'));
            }
        });
    };
    useMsgRenderCallback('mailMenuOper', ev => {
        const { _account } = ev;
        const { mailId } = ev.eventData;
        if ((ev === null || ev === void 0 ? void 0 : ev.eventStrData) == 'refreshWmMailDelivery' && _account == (content === null || content === void 0 ? void 0 : content._account) && mailId == mid) {
            handleRefresh();
        }
    });
    return (React.createElement(React.Fragment, null, recordInfo ? (React.createElement(React.Fragment, null,
        React.createElement(DeliveryInfo, { recordInfo: recordInfo }),
        React.createElement(DeliveryRecords, { recordInfo: recordInfo, onRefresh: handleRefresh, _account: content === null || content === void 0 ? void 0 : content._account }))) : null));
};
export default WmMailDeliveryHistory;
